import { AfterViewInit, Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// This is temporary fix for p-fieldset broken area reference accessibility issue
// can be ommited once PrimeNg library fixes its internal issue in future updates.
@Directive({
  selector: '[fieldsetAriaFix]',
  standalone: true
})
export class FieldsetAriaFixDirective implements AfterViewInit {
  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
    private translate: TranslateService
  ) {
    // Handles a wave bug caused by address-view component re-rendering when the language changes
    this.translate.onLangChange.subscribe(() => { 
      this.clearOldRefsAndGenNewRef();
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.handleBrokenAria();
    }, 300);
  }

  @HostListener('collapsedChange', ['$event'])
  clearOldRefsAndGenNewRef(event?) {
    setTimeout(() => {
      this.handleToggle();
    }, 500); // 500 ms to wait for the animation to complete
  }

  handleBrokenAria(): void {
    const content = this.element.nativeElement.querySelector('.p-toggleable-content');
    if (content) {
      const areaLabelledBy = content.getAttribute('aria-labelledby');
      const span = this.renderer.createElement('span');
      this.renderer.addClass(span, 'p-brokenaria-fix');
      this.renderer.setStyle(span, 'display', 'none');
      const text = this.renderer.createText('-');
      this.renderer.appendChild(span, text);
      this.renderer.setAttribute(span, 'id', areaLabelledBy);
      this.renderer.appendChild(content, span);
    }
  }

  handleToggle(): void {
    // removing previously added spans with legacy aria-labelledby references
    const content = this.element.nativeElement.querySelector('.p-toggleable-content');
    if (content) {
      const unwantedSpans = content.querySelectorAll('.p-brokenaria-fix');
      unwantedSpans.forEach(span => { this.renderer.removeChild(content, span) });
    }
    // adding new aria-labelledby references
    setTimeout(() => this.handleBrokenAria(), 100); // wait for aria attribute to be updated
  }

}